import { ErrorMessage, Field } from "formik";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { useFormikContext } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DateTime } from "luxon";

const TitleAndClientSection = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  // Convert ISO to local date object for editing (handled automatically as local)
  const scheduled = values.scheduledDate
    ? new Date(values.scheduledDate)
    : null;

  return (
    <>
      <Row>
        <Col>
          <FormGroup>
            <Label check>Title</Label>
            <Field
              name="title"
              type="text"
              className="form-control"
              placeholder="title"
            />
            <ErrorMessage
              name="title"
              component="span"
              className="text-danger"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label check>Description</Label>
            <Field
              name="description"
              type="text"
              className="form-control"
              placeholder="description"
            />
            <ErrorMessage
              name="description"
              component="span"
              className="text-danger"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label check>Slug</Label>
            <div
              style={{
                display: "flex",
                border: "1px solid #dee2e6",
                borderRadius: "0.375rem",
              }}
            >
              <span
                id="basic-addon3"
                className="input-group-text"
                style={{ borderRadius: 0, border: 0, fontSize: "14px" }}
              >
                https://www.start-smiling.co.uk/blog/
              </span>
              <Field
                name="slug"
                className="form-control"
                type="text"
                style={{ borderRadius: 0, border: "none" }}
                placeholder="slug"
              />
            </div>
            <ErrorMessage
              name="slug"
              component="span"
              className="text-danger"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label check>Schedule Date & Time (UK Standard time)</Label>
            <DatePicker
              selected={scheduled}
              onChange={(date: Date | null) => {
                if (date) {
                  // Convert picked Pakistan time → UTC ISO string
                  const utcISOString = DateTime.fromJSDate(date, {
                    zone: "Asia/Karachi",
                  })
                    .toUTC()
                    .toISO();
                  setFieldValue("scheduledDate", utcISOString);
                } else {
                  setFieldValue("scheduledDate", "");
                }
              }}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="yyyy-MM-dd HH:mm"
              className="form-control w-100"
              placeholderText="Select UK date and time"
              calendarClassName="rdp-cal"
            />
            <ErrorMessage
              name="scheduledDate"
              component="span"
              className="text-danger"
            />
            {/* dscsd */}
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};

export default TitleAndClientSection;
